import { UPDATE_MATCH_MARKETS } from './fishnet/actionTypes';

function updateMatchMarkets(response) {
  return {
    type: UPDATE_MATCH_MARKETS,
    payload: { response },
  };
}

export default updateMatchMarkets;
